export default __webpack_public_path__ + "book_details-dimensions.799d2853.png";